import { compareDates, formatDate } from '../common/formatDate';
import { DATE_FORMAT_ISO } from '../constants/dateFormat';

export function makeNoLaterThenValidator<T>(errorMsg: T, getMaxDate: () => string | undefined) {
  return (value: string) => {
    const maxDate = getMaxDate();
    if (!maxDate) {
      return undefined;
    }
    if (
      compareDates({
        dateLeft: formatDate({ date: value, dateFormat: DATE_FORMAT_ISO }),
        dateRigth: formatDate({ date: maxDate, dateFormat: DATE_FORMAT_ISO }),
      }) === 1
    ) {
      return errorMsg;
    }
    return undefined;
  };
}
